import React, { useEffect, useState } from 'react';
import useAuth from '../../../hooks/useAuth';
import './DashboardBanner.css';
import { Row, Col, Card, Modal, Button, Form, Spinner } from 'react-bootstrap';
import './DashboardBannerImage';
import DashboardBannerImage from './DashboardBannerImage';


const DashboardBanner = () => {
    const [banners, setBanners] = useState([]);
    useEffect(() => {
        fetch('https://gentle-tor-99938.herokuapp.com/banners')
            .then(res => res.json())
            .then((data) => setBanners(data))
    }, [])



    return (
        <div>
            {
                banners.length
                    ?
                    <div className="my-5">
                        <h2 className="mb-4 bg-dark text-white rounded-3 p-3 text-start fw-bold">Banner Images</h2>
                        <Row xs={1} md={2} className="g-4">
                            {
                                banners.map((banner, index) => <DashboardBannerImage
                                    banner={banner}
                                    key={banner.bannerID}
                                />)
                            }
                        </Row>

                    </div>
                    :
                    <div className="spinner d-flex align-items-center justify-content-center">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>

            }
        </div>
    );
};

export default DashboardBanner;